import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _class, _UppyMediaOptimization;
import { Promise } from "rsvp";
import { UploadPreProcessorPlugin } from "discourse/lib/uppy-plugin-base";
import { bind } from "discourse-common/utils/decorators";
let UppyMediaOptimization = (_class = (_UppyMediaOptimization = class UppyMediaOptimization extends UploadPreProcessorPlugin {
  constructor(uppy, opts) {
    super(uppy, opts);
    this.optimizeFn = opts.optimizeFn;

    // mobile devices have limited processing power, so we only enable
    // running media optimization in parallel when we are sure the user
    // is not on a mobile device. otherwise we just process the images
    // serially.
    this.runParallel = opts.runParallel || false;
  }
  _optimizeFile(fileId) {
    let file = this._getFile(fileId);
    this._emitProgress(file);
    return this.optimizeFn(file, {
      stopWorkerOnError: !this.runParallel
    }).then(optimizedFile => {
      let skipped = false;
      if (!optimizedFile) {
        this._consoleWarn("Nothing happened, possible error or other restriction, or the file format is not a valid one for compression.");
        skipped = true;
      } else {
        this._setFileState(fileId, {
          data: optimizedFile,
          size: optimizedFile.size
        });
      }
      this._emitComplete(file, skipped);
    }).catch(err => {
      this._consoleWarn(err);
      this._emitComplete(file);
    });
  }
  _optimizeParallel(fileIds) {
    return Promise.all(fileIds.map(this._optimizeFile));
  }
  async _optimizeSerial(fileIds) {
    let optimizeTasks = fileIds.map(fileId => () => this._optimizeFile(fileId));
    for (const task of optimizeTasks) {
      await task();
    }
  }
  install() {
    if (this.runParallel) {
      this._install(this._optimizeParallel);
    } else {
      this._install(this._optimizeSerial);
    }
  }
  uninstall() {
    if (this.runParallel) {
      this._uninstall(this._optimizeParallel);
    } else {
      this._uninstall(this._optimizeSerial);
    }
  }
}, _defineProperty(_UppyMediaOptimization, "pluginId", "uppy-media-optimization"), _UppyMediaOptimization), (_applyDecoratedDescriptor(_class.prototype, "_optimizeFile", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "_optimizeFile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_optimizeParallel", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "_optimizeParallel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_optimizeSerial", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "_optimizeSerial"), _class.prototype)), _class);
export { UppyMediaOptimization as default };